import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

export const StatisticsInfo: React.FC = () => {
  return <div id={"StatisticsInfo"}>
    <h2>
      Статистика и ТОП-100
    </h2>
    <p>
      В одноименном разделе Личного кабинета отображается информация, которая была получена от площадок за прошедшие
      сутки. Вы можете просматривать статистику по релизам прямо в интерфейсе Личного кабинета или сделать выгрузку
      статистики отдельным файлом.
    </p>
    <p>
      В статистике отображаются данные, полученные нами от площадок за прошедшие сутки. Если на момент формирования
      показателей площадками переданы ещё не все прослушивания, они будут учтены и дополнены на следующий день или
      позже.
    </p>
    <p>
      Обратите, пожалуйста, внимание, что в раздел статистики попадают все финансовые события без какой-либо валидации.
      По этой причине показатели статистики не всегда линейно репрезентативны в отношении ТОПов, для формирования
      которых ис пользуется намного больше фильтров, например, отсекаются накрутки, одновременные прослушивания с одного
      аккаунта и другие нюансы.
    </p>
  </div>;
};
